import { useState, useEffect, useRef } from 'react';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import { useStore } from '../../utils/store';
import Grid from '@mui/material/Grid2';
import HttpServices from '../../services/HttpService';
import Constants from '../../utils/constants';

import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import { useNavigate, useParams } from 'react-router-dom';
import CustomPaginationActionsTable from '../../components/TablePagination';

import shiftStore from './shiftStore';
import { downloadFile, getFormatDate } from '../../utils/storageUtil';
const ShiftMobilePrestart: React.FC = () => {
  const navigate = useNavigate();
  const isInitialLoad = useRef(true);
  const { crewId, shiftId } = useParams<{ crewId: any; shiftId: any }>();

  const [inProgress, setInProgress] = useState(false);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const { getAdmin } = useStore();
  const [itemData, setItemData] = useState<any[]>([]);
  const [currentRecord, setCurrentRecord] = useState<any>(
    shiftStore.shiftDetails
  );

  const columns: any[] = [
    {
      field: 'mobileAsset',
      headerName: 'Asset Number',
      valueGetter: (value: any, row: any) => {
        return value ? value.assetNumber : '-';
      },
    },
    {
      field: 'mobileAsset',
      headerName: 'Asset Name',
      valueGetter: (value: any, row: any) => {
        return value ? value.assetName : '-';
      },
    },
    {
      field: 'id',
      headerName: 'Status',
      renderCell: (value: any, row: any) => <Box>Completed</Box>,
    },
  ];

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      if (itemData.length === 0) fetchData();
      if (!currentRecord.projectId) {
        fetchShift();
      }
    }
  }, [shiftId]);

  const fetchData = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        `${Constants.apiURL}/map/list/${shiftId}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          id: shiftId,
          search: '',
          limit: -1,
          offset: 0,
        }
      );
      if (response.success) {
        setItemData(response.data);
      }
      console.log('GET Response:', response);
      setInProgress(false);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: 'No records found',
        open: true,
      });
      setInProgress(false);
    }
  };
  const fetchShift = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        Constants.apiURL + Constants.shiftURL + '/' + shiftId,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        setCurrentRecord(response.data);
        shiftStore.setDetails(response.data);
      }
      setInProgress(false);
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);

      setInProgress(false);
    }
  };
  const fetchPDF = async (id: any) => {
    try {
      setInProgress(true);
      const URL = `${Constants.apiURL}${Constants.documentPDFsURL}/fetchMAPPDF/${id}`;
      const response = await HttpServices.get(URL, {
        headers: {
          Authorization: 'Bearer ' + getAdmin(),
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      });
      setInProgress(false);

      if (response) {
        downloadFile(response, 'shift_MobilePrestart_' + id + '.pdf');
        window.open(response.data, '_blank');
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setInProgress(false);
    }
  };
  return (
    <Box className="main dashboardmain">
      <Box
        sx={{ width: '100%', padding: '20px' }}
        className="section dashboard"
      >
        <Box
          className="containergrid"
          sx={{
            padding: ' 16px',
          }}
        >
          {
            <Box>
              <Box
                onClick={() => {
                  navigate(
                    '/schedules/crews-schedule/' + crewId + '/' + shiftId
                  );
                }}
                style={{
                  cursor: 'pointer',
                  display: 'inline-flex',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <UTurnLeftIcon
                  sx={{
                    transform: 'rotate(90deg)',
                    cursor: 'pointer',
                  }}
                />
                <Typography>Back</Typography>
              </Box>
              {currentRecord && (
                <Paper
                  sx={{
                    padding: ' 16px',
                  }}
                >
                  {currentRecord.project && (
                    <Grid container>
                      <Grid size={3}>
                        <Typography variant="subtitle1">
                          Project Number
                          <Box sx={{ fontWeight: 'bold' }}>
                            {currentRecord.project.projectId}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid size={3}>
                        <Typography variant="subtitle1">
                          Customer
                          <Box sx={{ fontWeight: 'bold' }}>
                            {currentRecord.project.customerName}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid size={3}>
                        <Typography variant="subtitle1">
                          Shift Date
                          <Box sx={{ fontWeight: 'bold' }}>
                            {getFormatDate(currentRecord.date)}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid size={3}>
                        <Typography variant="subtitle1">
                          Site Address
                          <Box sx={{ fontWeight: 'bold' }}>
                            {currentRecord.siteAddress}
                          </Box>
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </Paper>
              )}
              <Paper sx={{ width: '100%', mt: 4 }} className="mt-4">
                <Box
                  sx={{
                    padding: '24px 16px 16px 16px',
                    mb: 2,
                    display: 'grid',
                    gap: '32px',
                    overflowX: 'scroll',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography
                      component={'h6'}
                      sx={{ mt: 4, fontWeight: '500' }}
                    >
                      {'Mobile Prestart'}
                    </Typography>
                    {inProgress && (
                      <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <CircularProgress sx={{ color: 'rgb(0, 244, 255)' }} />
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <CustomPaginationActionsTable
                      rows={itemData}
                      columns={columns}
                      totalRecords={itemData.length}
                      handlePagination={() => {}}
                      handleRowClick={(row) => {
                        fetchPDF(row.mapSignOffId);
                      }}
                      paginationModel={{
                        page: 0,
                        pageSize: -1,
                      }}
                      handleStatus={() => {}}
                      isPagingHide={true}
                    />
                  </Box>
                </Box>
              </Paper>
            </Box>
          }
        </Box>

        <AlertMessageComponent
          type={alert.type}
          open={alert.open}
          handleClose={handleCloseAlert}
          message={alert.message}
        />
      </Box>
    </Box>
  );
};
export default ShiftMobilePrestart;
